const generateKey = (length = 20) => {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let key = Date.now().toString();
  let i = 0;
  while (i < length) {
    key += possible.charAt(Math.floor(Math.random() * possible.length));
    i += 1;
  }
  return key;
};

export default generateKey;
